import { render, staticRenderFns } from "./SortArrows.vue?vue&type=template&id=2e444c21"
import script from "./SortArrows.vue?vue&type=script&lang=ts"
export * from "./SortArrows.vue?vue&type=script&lang=ts"
import style0 from "./SortArrows.vue?vue&type=style&index=0&id=2e444c21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports